module.exports = __webpack_public_path__ + "static/media/lbd26.84ff7817.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/lbd26.jpg
// module id = 207
// module chunks = 0